import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  engineer: {
    fullName: "",
    email: "",
    city: { value: "", label: "" },
    country: { value: "", label: "" },
    status: "",
    startDate: "",
    endDate: "",
    pagination: {
      page: 0,
      pageSize: 20,
    },
  },
  company: {
    companyName: "",
    companyType: "",
    manager: "",
    city: { value: "", label: "" },
    country: { value: "", label: "" },
    status: "",
    pagination: {
      page: 0,
      pageSize: 20,
    },
  },
  customer: {
    customerName: "",
    email: "",
    city: { value: "", label: "" },
    country: { value: "", label: "" },
    status: "",
    pagination: {
      page: 0,
      pageSize: 20,
    },
  },
  freelanceCompanyMembers: {
    fullName: "",
    email: "",
    status: "",
    pagination: {
      page: 0,
      pageSize: 10,
    },
  },
  customerAccountUsers: {
    fullName: "",
    email: "",
    country: { value: "", label: "" },
    status: "",
    pagination: {
      page: 0,
      pageSize: 20,
    },
  },
  companyUsers: {
    fullName: "",
    email: "",
    country: { value: "", label: "" },
    role: "",
    status: "",
    pagination: {
      page: 0,
      pageSize: 20,
    },
  },
};

const adminFiltersSlice = createSlice({
  name: "adminFilters",
  initialState,
  reducers: {
    setAdminFilters: (state, action) => {
      const { module, filterName, data } = action.payload;

      if (!state[module]) return; // guard against invalid module

      if (filterName.includes(".")) {
        const [parent, child] = filterName.split(".");
        if (state[module][parent]) {
          state[module][parent][child] = data;
        }
      } else {
        state[module][filterName] = data;
      }
    },

    resetAdminFilters: (state, action) => {
      const { module } = action.payload;
      if (initialState[module]) {
        state[module] = { ...initialState[module] };
      }
    },

    resetAdminPagination: (state, action) => {
      const { module } = action.payload;
      if (state[module]) {
        state[module].pagination = { page: 0, pageSize: 20 };
      }
    },
  },
});

export const {
  setAdminFilters,
  resetAdminFilters,
  resetAdminPagination,
} = adminFiltersSlice.actions;

export default adminFiltersSlice.reducer;
